import { LISTING_STATUS } from '@constants/property'
import { availableDate, filterHrefs, titleCase } from '@lib/helpers'

// Converts API data into the component props
export const formatListingData = (data, isListingRow = false) => {
  let dataSource = {}
  dataSource.id = data.id
  dataSource.address_display = data.address_display
  dataSource.address = data.address_street_display
    ? `${data.address_street_display.trim()}, ${data.address_suburb}`
    : data.address_suburb
  dataSource.priceGuide = data.priceView || data.price || 'Contact Agent'
  dataSource.features = []
  if (data.bedrooms) {
    dataSource.features.push({ icon: 'bedroom', label: data.bedrooms })
  } else if (isListingRow) {
    dataSource.features.push({ icon: 'bedroom', label: 0 })
  }
  if (data.bathrooms) {
    dataSource.features.push({ icon: 'bathroom', label: data.bathrooms })
  } else if (isListingRow) {
    dataSource.features.push({ icon: 'bathroom', label: 0 })
  }
  if (data.total_parking) {
    dataSource.features.push({ icon: 'garage', label: data.total_parking })
  }

  dataSource.image_url =
    data.images && data.images.length && data.images[0].image.image_800_600
  dataSource.image_mobile_url =
    data.images && data.images.length && data.images[0].image.image_320_240

  dataSource.url = data.get_absolute_url
  dataSource.address_postcode = data.address_postcode
  dataSource.auction_date = data.auction_date
  dataSource.status = data.status
  dataSource.soldDetails_price = data.soldDetails_price
  dataSource.soldDetails_price_display = data.soldDetails_price_display
  dataSource.soldDetails_date = data.soldDetails_date
  dataSource.listingType = data.listing_type
  dataSource.salebySetDate = data.salebySetDate
  dataSource.underOffer = data.underOffer
  dataSource.headline = data.headline
  dataSource.address_street_display = data.address_street_display
    ? data.address_street_display.trim()
    : ''
  dataSource.address_postcode = data.address_postcode
  dataSource.address_suburb = data.address_suburb
  dataSource.priceView = data.priceView
  dataSource.price_display = data.price_display
  dataSource.offmarket_status = data.offmarket_status
  dataSource.category = data.category
  dataSource.offmarket =
    data.status === 'offmarket' &&
    data.offmarket_status &&
    (data.offmarket_status === 'current' || data.offmarket_status === 'sold')
      ? true
      : false

  // Turn suburb to title case for offmarket listings
  if (dataSource.offmarket) dataSource.address = titleCase(dataSource.address)

  // handle offmarket listing status
  if (data.status && data.status === 'offmarket' && data.offmarket_status) {
    dataSource.status = data.offmarket_status
  }

  // first inspection
  if (data.inspections && data.inspections.length > 0)
    dataSource.inspection = data.inspections[0]
  else dataSource.inspection = null

  // "New" tag is created < 7 days ago
  const createdDate = new Date(data.created)
  const ONE_WEEK = 60 * 60 * 24 * 7 * 1000 // Milliseconds
  if (new Date() - createdDate < ONE_WEEK) {
    dataSource.new = true
  }

  // listing available date
  if (data.listing_type == 'lease' && data.dateAvailable) {
    dataSource.dateAvailable = availableDate(data.dateAvailable)
  }

  // hrefs
  const hrefs = filterHrefs(data, 'onlineauctions')
  if (hrefs.onlineauctions) dataSource.onlineauctions = hrefs.onlineauctions

  dataSource.liveAuctionUrl = data.live_auction_url
  dataSource.liveAuctionRegisterUrl = data.live_auction_register_url

  // Data attributes
  dataSource.office = data.office
  dataSource.created = data.created
  dataSource.updated = data.updated
  dataSource.agent_ids = data.agent_ids
  dataSource.uniqueID = data.uniqueID

  dataSource.description = data.description
  dataSource.listingFeatures = data.features?.filter(
    (it) => it.name !== 'openSpaces'
  )

  dataSource.isMultiple = data.isMultiple
  dataSource.price_range_min = data.price_range_min
  dataSource.price_range_max = data.price_range_max

  return dataSource
}

function extractFirstNumber(input) {
  const match = input.match(/\$\d{1,3}(,\d{3})*(\.\d+)?/)
  if (match) {
    const number = match[0].replace(/[$,]/g, '')
    return number
  }
  return ''
}

export const getListingPrice = (listing) => {
  if (
    listing.status !== LISTING_STATUS.SOLD &&
    listing.status !== LISTING_STATUS.LEASED
  ) {
    if (listing.price_display) {
      if (listing.priceView) {
        return extractFirstNumber(listing.priceView)
      }
    }
  } else {
    if (listing.soldDetails_price_display) {
      return listing.soldDetails_price
    }
  }

  return ''
}
